module.exports = __webpack_public_path__ + "static/media/campusImgF.e133bfd9.png";